export const DEFAULT_BASE_CURRENCY = 'USD'
export const DEFAULT_CRYPTO_ASSET = 'USDT'
export const DEFAULT_ASSET_NETWORK = 'TRX'

export const formKeys = {
  cryptoAmount: 'cryptoAmount',
  fiatAmount: 'fiatAmount',
  name: 'name',
  isAnon: 'isAnon',
  donationType: 'donationType',
  message: 'message',
  voice: 'voice',
  youtubeLink: 'youtubeLink',
  youtubeStart: 'youtubeStart',
  image: 'image',
  audio: 'audio',
  isIncludeFee: 'isIncludeFee',
  baseCurrency: 'baseCurrency',
  selectedCryptoAsset: 'selectedCryptoAsset',
  selectedNetwork: 'selectedNetwork',
  selectedFiatProvider: 'selectedFiatProvider',
  paymentType: 'paymentType',
  customizeType: 'customizeType',
  country: 'country',
  state: 'state',
  goal: 'goal',
} as const
